<!--
 * @Author: goldeneyes.li
 * @Date: 2022-11-01 14:08:09
 * @LastEditTime: 2022-11-01 14:08:09
 * @LastEditors: goldeneyes.li
 * @Description: 404页面
-->
<template>
    <div class="page-404"></div>
</template>

<script setup name="404"></script>

<style lang="scss" scoped></style>
